// lbl.profile
export const profile = {
    firstname: {
        name: 'Firstname',
        placeholder: 'Firstname',
        required: 'Please enter firstname',
        too_short: 'กรุณาระบุตัวอักษรภาษาไทย หรืออังกฤษ {0} ตัวอักษรขึ้นไป',
        invalid: '',
    },
    lastname: {
        name: 'Lastname',
        placeholder: 'Lastname',
        required: 'Please enter lastname',
        too_short: 'กรุณาระบุตัวอักษรภาษาไทย หรืออังกฤษ {0} ตัวอักษรขึ้นไป',
        invalid: '',
    },
    contactNumber: {
        name: 'Contact number',
        placeholder: 'Contact number',
        required: 'Contact number',
        too_short: 'Contact number must be {0} digits',
        invalid: 'Incorrect contact number format',
    },
    email: {
        name: 'Email',
        placeholder: 'Email',
        required: 'Please enter email address',
        too_short: '',
        invalid: 'Incorrect email format',
    },
    idCard: {
        name: 'ID card',
        placeholder: 'ID card',
        required: 'Pleae enter ID card',
        too_short: 'Pleae enter ID card 13 digits',
        invalid: 'ID card invalid',
    },
    password: {
        name: 'Password',
        placeholder: 'Password',
        required: 'Please enter passwrod',
        too_short: '',
        invalid: '',
    },
    gender: {
        name: 'Gender',
        placeholder: 'Please select',
        required: 'Please select gender',
        too_short: '',
        invalid: '',
    },
    birthdate: {
        name: 'Birthdate',
        placeholder: '',
        required: 'Please select birthdate',
        too_short: '',
        invalid: 'Birthdate invalid',
        date: {
            name: '',
            placeholder: 'Day',
            defaultText: 'Day',
            required: ' '
        },
        month: {
            name: '',
            placeholder: 'Month',
            defaultText: 'Month',
            required: ' '
        },
        year: {
            name: '',
            placeholder: 'Year',
            defaultText: 'Year',
            required: ' '
        },
    },
    zipcode: {
        name: 'Zipcode',
        placeholder: 'Zipcode',
        required: 'Please enter zipcode',
        too_short: 'Zipcode must be {0} digits',
        invalid: 'Invalid zipcode',
    },
    number: {
        name: 'บ้านเลขที่',
        placeholder: 'กรุณากรอกบ้านเลขที่',
        required: 'กรุณากรอกบ้านเลขที่',
        too_short: '',
        invalid: '',
    },
    soi: {
        name: 'ซอย',
        placeholder: 'กรุณากรอกซอย',
        required: '',
        too_short: '',
        invalid: '',
    },
    road: {
        name: 'ถนน',
        placeholder: 'กรุณากรอกถนน',
        required: '',
        too_short: '',
        invalid: '',
    },
    subdistrict: {
        name: 'Sub district',
        placeholder: 'Please selece sub-district',
        required: 'Please selece sub-district',
        too_short: '',
        invalid: '',
    },
    district: {
        name: 'District',
        placeholder: 'Please selece district',
        required: 'Please selece district',
        too_short: '',
        invalid: '',
    },
    province: {
        name: 'Province',
        placeholder: 'Please selece province',
        required: 'Please selece province',
        too_short: '',
        invalid: '',
    },

    male: "Male",
    female: "Female",
    notspecified: "Notspecified",

    text_login: 'กรุณาเข้าสู่ระบบ<br/>เพื่อรับสิทธิพิเศษ',
    login: 'เข้าสู่ระบบ',

    text_page: {
        my_medal: 'เหรียญตราของฉัน',
        history: 'ประวัติการใช้งาน',
        helpchat: 'สอบถามออนไลน์',
        faq: 'คำถามที่พบบ่อย',
        contactus: 'ติดต่อเรา',
        privacy: 'รายละเอียดข้อมูลส่วนบุคคลของสมาชิก S Plus+',
        terms: 'ข้อตกลงและเงื่อนไข',
        personal_data_policy: 'นโยบายคุ้มครองข้อมูลส่วนบุคคล'
    },

    mobile_number: {
        name: 'การเปลี่ยนเบอร์โทรศัพท์',
        input_number_text: 'กรุณาระบุเบอร์โทรศัพท์ใหม่ เพื่อรับรหัส OTP<br/>เบอร์โทรศัพท์ปัจจุบันของคุณคือ',
        placeholder: 'กรุณาระบุเบอร์โทรศัพท์ใหม่',
        required: 'กรุณาระบุเบอร์มือถือใหม่ของคุณ 10 หลัก',
        too_short: 'กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก <br/>และตัวแรกของเบอร์โทรศัพท์เท่ากับ 0',
        invalid: '',
    },
    otp: {
        name: 'กรุณาระบุรหัส OTP',
        request_otp: 'กดเพื่อรับรหัส OTP ทาง SMS',
        required: 'กรุณาระบุรหัส OTP',

        refcode_lbl: 'Ref.Code : ',
        time_left: 'เวลาที่เหลือ : ',

        time_left_text: 'รหัส OTP ของคุณหมดอายุแล้ว<br/>กรุณากดเพื่อรับรหัส OTP ใหม่',
    },
    error: {
        error409: 'คุณระบุเบอร์โทรศัพท์หมายเลขเดิม<br/>กรุณาระบุหมายเลขโทรศัพท์ใหม่'
    }
};
